<template>
  <v-card-text>
    <v-data-iterator :items="pressNotes" :items-per-page="10" :page="1">
      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.id"
            cols="12"
            lg="3"
            md="6"
            sm="12"
          >
            <CardPressNotes
              :item="item"
              :srcImage="loadImage(item.img_press_notes)"
              @edit="$emit('edit', item)"
              @remove="$emit('remove', item)"
            ></CardPressNotes>

          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </v-card-text>
</template>

<script>
import CardPressNotes from "@/components/cards/CardPressNotes.vue";
import { loadAPIImage } from "@/utils/images";
export default {
  components: {
    CardPressNotes,
  },
  props: {
    pressNotes: Array,
  },
  methods: {
    loadImage(src) {
      return loadAPIImage(src);
    },
  },
};
</script>

<style lang="scss" scoped></style>
